// Loupe360 (and similar) embeds are served as a fixed 500x500 player.
// The iframe is rendered at that native size in CSS and scaled down here
// with a transform so it fits the card without clipping its content.
function scaleDiamondVideoFrame(frame) {
  if (!frame) return;
  var iframe = frame.querySelector('[data-video-embed]');
  if (!iframe) return;
  var width = frame.clientWidth;
  if (!width) return;
  iframe.style.transform = 'scale(' + width / 500 + ')';
}

function scaleActiveDiamondVideoFrames() {
  document.querySelectorAll('[data-media-panel="video"].is-active [data-video-frame]').forEach(scaleDiamondVideoFrame);
}

window.addEventListener('resize', scaleActiveDiamondVideoFrames);

document.addEventListener('DOMContentLoaded', function () {
  scaleActiveDiamondVideoFrames();

  document.querySelectorAll('[data-diamond-card]').forEach(function (card) {
    var toggleButtons = card.querySelectorAll('[data-media-toggle]');

    toggleButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var target = button.getAttribute('data-media-toggle');

        toggleButtons.forEach(function (btn) {
          var isActive = btn === button;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        card.querySelectorAll('[data-media-panel]').forEach(function (panel) {
          var isActive = panel.getAttribute('data-media-panel') === target;
          panel.classList.toggle('is-active', isActive);

          var video = panel.querySelector('video');
          if (video) {
            if (isActive) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          }

          if (isActive) {
            scaleDiamondVideoFrame(panel.querySelector('[data-video-frame]'));
          }
        });
      });
    });
  });
});
